import "../pages.scss";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useFilters } from "../../context/FiltersContext";
import { DepositosState } from '../../context/depositos/DepositosState';
import Datatable from "./depositosTable/Datatable"

const DepositosPage = () => {
  const { clearFilters } = useFilters();
  const location = useLocation();

  useEffect(() => {
    // Si NO viene desde detalle → limpiar filtros
    if (!location.state?.fromDetail) {
      clearFilters("depositos");
    }
  }, []);

  return (
    <>
      <DepositosState>
        <Datatable />
      </DepositosState>

    </>
  )
}

export default DepositosPage